var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluefeatheredhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714 410.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3160bc;}.cls-2{fill:#120e24;}.cls-3{fill:#223f88;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.36,138.59s177-192.64,354.64,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.54,145.18S567.5,27.09,659.46,0c0,0-16.82,53.44-22.48,65.05L603,85.18l29-3.47S565.69,149.44,525.54,145.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357,113.59c-197.17,0-357,82.38-357,184C0,340,27.85,379.06,74.64,410.18,79,364.73,94,288.44,145.78,242.63c35.58-31.5,73.66-53.92,107.57-65.38h0a184.32,184.32,0,0,1,21.53-5.92c32.92-8,98.77-20,163.19-7.84h0c41.21,5.42,94.76,35.14,142.26,82.64,47.16,47.16,60,117.43,63.1,161.29C687.76,376.76,714,338.75,714,297.59,714,196,554.17,113.59,357,113.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluefeatheredhat);
export default __webpack_public_path__ + "static/media/blue feathered hat.f831e54e.svg";
export { ForwardRef as ReactComponent };